import { render, staticRenderFns } from "./submission-panel.vue?vue&type=template&id=54c39732&scoped=true&"
import script from "./submission-panel.vue?vue&type=script&lang=ts&"
export * from "./submission-panel.vue?vue&type=script&lang=ts&"
import style0 from "./submission-panel.vue?vue&type=style&index=0&id=54c39732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c39732",
  null
  
)

export default component.exports